(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dt-contact"]) return;
  try {
    
  if (!customElements.get('dt-contact-form')) {
    customElements.define('dt-contact-form', class extends HTMLElement {
      connectedCallback() {
        if (this.observer) return;
        const enhance = () => {
          const form = this.querySelector('form');
          if (!form) return;
          const name = form.querySelector('input[name="Nom et prénom"]');
          const email = form.querySelector('input[name="Adresse e-mail"]');
          const phone = form.querySelector('input[name="Numéro de téléphone"]');
          const message = form.querySelector('textarea[name="Commentaire"]');
          const submit = form.querySelector('button[type="submit"]');
          if (!name || !email || !phone || !message || !submit) return;
          name.autocomplete = 'name';
          email.autocomplete = 'email';
          email.setAttribute('autocapitalize', 'none');
          phone.type = 'tel';
          phone.inputMode = 'tel';
          phone.autocomplete = 'tel';
          email.id = email.id || this.id + '-email';
          [name, email, phone, message].forEach(input => {
            const label = input.parentElement.querySelector('label.block_label');
            if (!label) return;
            label.htmlFor = input.id;
            if (input === message && this.dataset.messageLabel) label.textContent = this.dataset.messageLabel;
            input.setAttribute('aria-label', label.textContent);
            input.removeAttribute('placeholder');
          });
          const label = Array.from(submit.childNodes).find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
          if (label && this.dataset.submitLabel) label.textContent = this.dataset.submitLabel;
          this.observer.disconnect();
        };
        this.observer = new MutationObserver(enhance);
        this.observer.observe(this, { childList: true, subtree: true });
        enhance();
      }
      disconnectedCallback() { if (this.observer) { this.observer.disconnect(); this.observer = null; } }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dt-faq-hub"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dt-faq-hub')) {
  customElements.define('dt-faq-hub', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-faq-input]');
      this.status = this.querySelector('[data-faq-status]');
      this.empty = this.querySelector('[data-faq-empty]');
      this.nav = this.querySelector('[data-faq-nav]');
      this.clear = this.querySelector('[data-faq-clear]');
      this.groups = Array.from(this.querySelectorAll('[data-faq-group]'));
      if (!this.input || !this.status || !this.empty || !this.clear) return;
      this.onInput = () => this.filter();
      this.onClear = () => { this.input.value = ''; this.filter(); this.input.focus(); };
      this.input.addEventListener('input', this.onInput);
      this.clear.addEventListener('click', this.onClear);
      this.querySelector('[data-faq-search]').hidden = false;
      this.filter();
    }
    disconnectedCallback() {
      this.input?.removeEventListener('input', this.onInput);
      this.clear?.removeEventListener('click', this.onClear);
    }
    normalize(value) { return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim(); }
    filter() {
      const query = this.normalize(this.input.value);
      let count = 0;
      this.groups.forEach(group => {
        let visible = 0;
        group.querySelectorAll('details').forEach(item => {
          const match = !query || this.normalize(item.textContent).includes(query);
          item.hidden = !match;
          if (match) { visible += 1; count += 1; }
        });
        group.hidden = visible === 0;
      });
      this.empty.hidden = count > 0;
      this.clear.hidden = !query;
      if (this.nav) this.nav.hidden = Boolean(query);
      this.status.textContent = (count === 1 ? this.dataset.one : this.dataset.many).replace('[nb]', String(count));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dt-formations"]) return;
  try {
    
  if (!customElements.get('dt-course-catalog')) {
    customElements.define('dt-course-catalog', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.controls = this.querySelector('.dtf-filters');
        this.cards = Array.from(this.querySelectorAll('[data-course-category]'));
        this.counter = this.querySelector('.dtf-count');
        if (!this.controls) return;
        this.controls.hidden = false;
        this.controls.addEventListener('click', event => {
          const button = event.target.closest('button[data-category]');
          if (!button) return;
          const category = button.dataset.category;
          this.controls.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          let count = 0;
          this.cards.forEach(card => {
            card.hidden = category !== 'all' && card.dataset.courseCategory !== category;
            if (!card.hidden) count += 1;
          });
          this.counter.textContent = `${count} ${count === 1 ? this.dataset.singular : this.dataset.plural}`;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dt-inscription"]) return;
  try {
    
  if (!customElements.get('dt-registration-form')) {
    customElements.define('dt-registration-form', class extends HTMLElement {
      connectedCallback() {
        if (this.observer) return;
        const messages = new Map([
          ['Nom is required', this.dataset.requiredName],
          ['Adresse e-mail is required', this.dataset.requiredEmail],
          ['Téléphone is required', this.dataset.requiredPhone],
          ['Quelles formations vous intéressent ? is required', this.dataset.requiredCourse],
          ['Veuillez cocher votre statut is required', this.dataset.requiredStatus],
          ['Financement is required', this.dataset.requiredFunding]
        ]);
        const enhance = () => {
          this.querySelectorAll('[role="alert"] p').forEach(error => {
            const original = error.textContent.trim().replace(/\s+/g, ' ');
            const translation = messages.get(original);
            if (translation && original !== translation) {
              error.textContent = translation;
              error.setAttribute('aria-label', translation);
            }
          });
          const close = this.querySelector('[role="alert"] button[aria-label="Close"]');
          if (close) close.setAttribute('aria-label', this.dataset.errorClose);
          this.querySelectorAll('input[type="checkbox"]').forEach(input => {
            if (!/^hydra\s*faciale?$/i.test(input.value.trim())) return;
            const label = this.querySelector('label[for="' + CSS.escape(input.id) + '"]');
            if (!label) return;
            const walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT);
            let node;
            while ((node = walker.nextNode())) {
              if (/^hydra\s*faciale?$/i.test(node.textContent.trim())) {
                node.textContent = this.dataset.hydraCourseName;
              }
            }
          });
          const form = this.querySelector('form');
          const submit = form && form.querySelector('button[type="submit"]');
          const name = form && form.querySelector('input[name="Nom "]');
          const email = form && form.querySelector('input[name="Adresse e-mail"]');
          const phone = form && form.querySelector('input[name="Téléphone"]');
          if (!submit || !name || !email || !phone) return;
          if (!form.dataset.dtiValidationReady) {
            form.dataset.dtiValidationReady = 'true';
            const courseGroup = form.querySelector('.formElement_3');
            const fields = [
              { controls: [name], group: name.closest('.form-group'), message: this.dataset.requiredName },
              { controls: [email], group: email.closest('.form-group'), message: this.dataset.requiredEmail },
              { controls: [phone], group: phone.closest('.form-group'), message: this.dataset.requiredPhone },
              { controls: [...(courseGroup?.querySelectorAll('input[type="checkbox"]') || [])], group: courseGroup, message: this.dataset.requiredCourse, choice: true }
            ].filter(field => field.group && field.controls.length);
            let attempted = false;
            const setError = (field, message) => {
              let error = field.group.querySelector('.dti-field-error');
              if (!error && message) {
                error = document.createElement('p');
                error.className = 'dti-field-error';
                error.id = 'dti-error-' + field.controls[0].id;
                error.setAttribute('aria-live', 'polite');
                field.group.append(error);
              }
              if (!error) return;
              if (error.textContent !== message) error.textContent = message;
              error.hidden = !message;
              field.controls.forEach(control => {
                const ids = new Set((control.getAttribute('aria-describedby') || '').split(' ').filter(Boolean));
                if (message) {
                  ids.add(error.id);
                  control.setAttribute('aria-invalid', 'true');
                } else {
                  ids.delete(error.id);
                  control.removeAttribute('aria-invalid');
                }
                if (ids.size) control.setAttribute('aria-describedby', [...ids].join(' '));
                else control.removeAttribute('aria-describedby');
              });
            };
            const validateField = field => {
              let message = '';
              if (field.choice ? !field.controls.some(control => control.checked) : !field.controls[0].value.trim()) message = field.message;
              else if (field.controls[0] === email && email.validity.typeMismatch) message = this.dataset.invalidEmail;
              setError(field, message);
              return !message;
            };
            const guard = event => {
              if (event.type === 'click' && !event.target.closest('button[type="submit"]')) return;
              attempted = true;
              const invalid = fields.filter(field => !validateField(field));
              if (!invalid.length) return;
              event.preventDefault();
              event.stopImmediatePropagation();
              const field = invalid[0];
              const disclosure = field.group.closest('details');
              if (disclosure) disclosure.open = true;
              field.controls[0].focus({ preventScroll: true });
              field.group.scrollIntoView({ behavior: 'auto', block: 'center' });
            };
            form.addEventListener('click', guard, true);
            form.addEventListener('submit', guard, true);
            form.addEventListener('invalid', event => {
              const field = fields.find(field => field.controls.includes(event.target));
              if (field) validateField(field);
            }, true);
            fields.forEach(field => field.controls.forEach(control => {
              ['input', 'change'].forEach(type => control.addEventListener(type, () => {
                if (attempted || control.getAttribute('aria-invalid') === 'true') validateField(field);
              }));
              control.addEventListener('blur', () => {
                if (attempted || control.value.trim()) validateField(field);
              });
            }));
          }

          const course = form.querySelector('.formElement_3');
          if (course && !course.closest('.dti-course-choice') && course.querySelector('input:checked')) {
            const details = document.createElement('details');
            details.className = 'dti-course-choice';
            const summary = document.createElement('summary');
            summary.textContent = this.dataset.courseLabel;
            course.before(details);
            details.append(summary, course);
            course.addEventListener('change', () => {
              if (!course.querySelector('input:checked')) details.open = true;
            });
          }
          const container = form.querySelector('.form_container');
          if (container && !container.querySelector('.dti-optional')) {
            const optional = [4, 5, 6].map(index => container.querySelector('.formElement_' + index));
            if (optional.every(group => group && !group.querySelector('[required]'))) {
              const details = document.createElement('details');
              details.className = 'dti-optional';
              const summary = document.createElement('summary');
              summary.textContent = this.dataset.optionalLabel;
              details.append(summary);
              container.insertBefore(details, optional[0]);
              optional.forEach(group => details.append(group));
            }
          }
          form.querySelectorAll('.dti-course-choice > summary, .dti-optional > summary').forEach(summary => {
            if (summary.dataset.toggleReady) return;
            summary.dataset.toggleReady = 'true';
            summary.addEventListener('click', event => {
              event.preventDefault();
              event.stopPropagation();
              summary.parentElement.open = !summary.parentElement.open;
            });
          });
          name.autocomplete = 'name';
          email.autocomplete = 'email';
          email.setAttribute('autocapitalize', 'none');
          phone.type = 'tel';
          phone.inputMode = 'tel';
          phone.autocomplete = 'tel';
          const label = Array.from(submit.childNodes).find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
          if (label && this.dataset.submitLabel && label.textContent !== this.dataset.submitLabel) label.textContent = this.dataset.submitLabel;
        };
        this.observer = new MutationObserver(enhance);
        this.observer.observe(this, { childList: true, characterData: true, subtree: true });
        enhance();
      }
      disconnectedCallback() { if (this.observer) { this.observer.disconnect(); this.observer = null; } }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dt-planifier-rdv"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dt-calendly-loader')) {
    customElements.define('dt-calendly-loader', class extends HTMLElement {
      connectedCallback() {
        if (this.observer) return;
        const mount = this.querySelector('.calendly-inline-widget');
        const loading = this.querySelector('[data-calendar-loading]');
        const status = this.querySelector('[data-calendar-status]');
        const ready = this.querySelector('[data-calendar-ready]');
        this.onMessage = event => {
          if (event.origin !== 'https://calendly.com' || !event.data) return;
          if (!['calendly.event_type_viewed', 'calendly.profile_page_viewed', 'calendly.date_and_time_selected'].includes(event.data.event)) return;
          const frame = mount.querySelector('iframe');
          if (!frame || event.source !== frame.contentWindow) return;
          this.dataset.calendarState = 'ready';
          loading.hidden = true;
          ready.textContent = this.dataset.readyCopy;
          clearTimeout(this.slowTimer);
        };
        window.addEventListener('message', this.onMessage);
        const nameFrame = () => {
          const frame = mount.querySelector('iframe');
          if (frame) frame.title = this.dataset.frameTitle;
        };
        this.observer = new MutationObserver(nameFrame);
        this.observer.observe(mount, { childList: true });
        nameFrame();
        this.slowTimer = setTimeout(() => {
          if (this.dataset.calendarState === 'ready') return;
          this.dataset.calendarState = 'slow';
          status.textContent = this.dataset.slowCopy;
        }, 12000);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
        window.removeEventListener('message', this.onMessage);
        clearTimeout(this.slowTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dt-quote-guide"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dt-devis-guide')) {
  customElements.define('dt-devis-guide', class extends HTMLElement {
    connectedCallback() {
      this.copyButton = this.querySelector('[data-copy-devis]');
      this.message = this.querySelector('[data-devis-message]');
      this.status = this.querySelector('[data-copy-status]');
      if (!this.copyButton || !this.message || !this.status) return;
      this.onCopy = this.onCopy || this.copyMessage.bind(this);
      this.copyButton.addEventListener('click', this.onCopy);
      this.copyButton.hidden = false;
    }
    disconnectedCallback() {
      if (this.copyButton && this.onCopy) this.copyButton.removeEventListener('click', this.onCopy);
    }
    async copyMessage() {
      this.copyButton.disabled = true;
      this.status.textContent = '';
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(this.message.value.trim());
        } else {
          this.message.focus();
          this.message.select();
          if (!document.execCommand('copy')) throw new Error('Copy unavailable');
          this.copyButton.focus();
        }
        this.status.textContent = this.copyButton.dataset.success;
      } catch {
        this.message.focus();
        this.message.select();
        this.status.textContent = this.copyButton.dataset.error;
      } finally {
        this.copyButton.disabled = false;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dt-results-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dt-results-gallery')) {
    customElements.define('dt-results-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.galleryController) return;
        const dialog = this.querySelector('[data-results-dialog]');
        const links = Array.from(this.querySelectorAll('[data-results-open]'));
        if (!dialog || !links.length || typeof dialog.showModal !== 'function') return;
        this.galleryController = new AbortController();
        const options = {signal: this.galleryController.signal};
        const cards = Array.from(this.querySelectorAll('.dt-results__card'));
        const before = dialog.querySelector('[data-results-before]');
        const after = dialog.querySelector('[data-results-after]');
        const description = dialog.querySelector('[data-results-description]');
        const title = dialog.querySelector('[data-results-title]');
        const count = dialog.querySelector('[data-results-count]');
        const previous = dialog.querySelector('[data-results-previous]');
        const next = dialog.querySelector('[data-results-next]');
        let index = 0;
        let returnFocus = null;
        let overflow = '';
        const show = position => {
          index = position;
          const card = cards[index];
          const pair = card.querySelectorAll('[data-results-open]');
          before.src = pair[0].href;
          before.alt = pair[0].querySelector('img').alt;
          after.src = pair[1].href;
          after.alt = pair[1].querySelector('img').alt;
          title.textContent = card.querySelector('.dt-results__card-heading > span').textContent;
          description.textContent = card.querySelector('.dt-results__description')?.textContent || '';
          description.hidden = !description.textContent.trim();
          count.textContent = `${index + 1} / ${cards.length}`;
          previous.disabled = index === 0;
          next.disabled = index === cards.length - 1;
        };
        const restore = () => {
          document.body.style.overflow = overflow;
          before.removeAttribute('src');
          after.removeAttribute('src');
          if (returnFocus?.isConnected) returnFocus.focus({preventScroll: true});
          returnFocus = null;
        };
        links.forEach(link => link.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          returnFocus = link;
          overflow = document.body.style.overflow;
          show(cards.indexOf(link.closest('.dt-results__card')));
          dialog.showModal();
          document.body.style.overflow = 'hidden';
        }, options));
        dialog.querySelector('[data-results-close]').addEventListener('click', () => dialog.close(), options);
        previous.addEventListener('click', () => { if (index > 0) show(index - 1); }, options);
        next.addEventListener('click', () => { if (index < cards.length - 1) show(index + 1); }, options);
        dialog.addEventListener('close', restore, options);
        dialog.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' && index < cards.length - 1) { event.preventDefault(); show(index + 1); }
          if (event.key === 'ArrowLeft' && index > 0) { event.preventDefault(); show(index - 1); }
        }, options);
        dialog.addEventListener('click', event => {
          const bounds = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
        }, options);
        this.closeGallery = () => { if (dialog.open) { dialog.close(); restore(); } };
      }
      disconnectedCallback() {
        this.closeGallery?.();
        this.galleryController?.abort();
        this.galleryController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dt-trico-google-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dt-trico-carousel')) {
    customElements.define('dt-trico-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const track = this.querySelector('.dt-trico-reviews__grid');
        const cards = [...track.children];
        const controls = this.querySelector('.dt-trico-reviews__controls');
        const previous = controls.querySelector('[data-direction="-1"]');
        const next = controls.querySelector('[data-direction="1"]');
        const position = controls.querySelector('.dt-trico-reviews__position');
        const step = () => cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
        const update = () => {
          const max = track.scrollWidth - track.clientWidth;
          controls.hidden = max < 2;
          previous.disabled = track.scrollLeft < 2;
          next.disabled = track.scrollLeft >= max - 2;
          position.textContent = `${Math.round(track.scrollLeft / step()) + 1} / ${cards.length}`;
        };
        const move = direction => track.scrollTo({ left: Math.max(0, Math.min(cards.length - 1, Math.round(track.scrollLeft / step()) + direction)) * step(), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        previous.addEventListener('click', () => move(-1), options);
        next.addEventListener('click', () => move(1), options);
        track.addEventListener('scroll', update, { ...options, passive: true });
        track.addEventListener('keydown', event => {
          if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    

if(!customElements.get('dt-refined-footer-menu')){
 customElements.define('dt-refined-footer-menu',class extends HTMLElement{
  connectedCallback(){
   if(this.media)return;
   this.details=this.querySelector('details');
   this.summary=this.querySelector('summary');
   if(!this.details||!this.summary)return;
   this.media=window.matchMedia('(max-width:749px)');
   this.sync=()=>{this.details.open=!this.media.matches;this.summary.tabIndex=this.media.matches?0:-1;};
   this.handleClick=(event)=>{if(!this.media.matches)event.preventDefault();};
   this.sync();
   this.summary.addEventListener('click',this.handleClick);
   this.media.addEventListener('change',this.sync);
  }
  disconnectedCallback(){
   this.summary?.removeEventListener('click',this.handleClick);
   this.media?.removeEventListener('change',this.sync);
   this.media=null;
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
